<div class="sidebar">
  <div class="content p7ehc-1" style="padding-top: 0px; padding-bottom: 0px; height: auto;">
    <div id="p7EHCd_2">
      <div id="p7DMM_2" class="p7DMM01 p7DMM p7dmm-left responsive dmm-vertical">
        <img src="/assets/images/logo.png" />
        <ul id="p7DMMu_2" class="p7DMM01-menu closed">
          <li class="closed">
            <a id="home" title="Home" (click)="goHome()" class="closed">Home</a>
          </li>
          <li class="closed">
            <a id="Torns" title="Torns" runat="server" (click)="goTorns()" class="closed">Tournaments</a>
          </li>
          <li class="closed">
            <a id="PlayerHistory" title="PlayerHistory" runat="server" (click)="goHistory()" class="closed">Player History</a>
          </li>
          <li class="closed">
            <a id="ShowRankings" title="ShowRankings" (click)="goRankings()" class="closed">Rankings</a>
          </li>
          <li class="closed">
            <a id="ShowChart" title="ShowChart" (click)="goChart()" class="closed">Player Comparison</a>
          </li>
          <li class="closed-menu">
            <!-- <a id="p7DMMt2_5" class="closed-menu" #TheMatMenuTrigger [matMenuTriggerFor]="Gallery" (mouseenter)="someMethod()" (focusOut)="hideMenu()" (click)="hideMenu()">Gallery</a>
            <mat-menu #Gallery="matMenu" id="GalleryMenu" >
              <button mat-menu-item *ngFor="let folder of GalleryFolders; let i = index" (click)="ShowTheImages(i)" >{{folder[0]}}</button>
            </mat-menu> -->
            <a id="p7DMMt2_5" (mouseover)="showSubMenu[1] = true;hoverLinks = true;" (mouseleave)="delayedLeave(1)">Gallery</a>
            @if (showSubMenu[1] == true && GalleryFolders) {
              <div id="p7DMMs2_3" class="p7dmm-sub-wrapper" style="height: 0px;">
                <ul class="scroll" (mouseover)="hoverScroll = true;showSubMenu[1] = true;" (mouseleave)="ScrollDelayedLeave(1)">
                  <!-- <button *ngFor="let folder of GalleryFolders; let i = index" (click)="ShowTheImages(i)"  (mouseover)="this.hoverScroll = true;this.showSubMenu = true;" (mouseleave)="ScrollDelayedLeave()" >{{folder[0]}}</button> -->
                  @for (folder of GalleryFolders; track folder; let i = $index) {
                    <li><a (click)="ShowTheImages(i)" >{{folder[0]}}</a></li>
                  }
                </ul>
              </div>
            }
          </li>
          <li class="closed">
            <a id="Rules" title="Rules" (click)="goRules()" class="closed">Rules</a>
          </li>
          <li><a Href="Http://www.facebook.com/racketlonNZ/" target="_blank">Racketlon NZ Facebook Page</a></li>
          <li class="closed">
            <a id="Interested1" title="Interested?" (click)="joinMailingList()" class="closed">Join Racketlon NZ Mailing List</a>
          </li>
          <li class="closed">
            <a id="Contact" title="Contact" Href="mailto: racketlonnz@yahoo.com" class="closed">Contact</a>
          </li>
          <li class="closed-menu">
            <a id="p7DMMt2_5" title="Links" class="closed-menu" (mouseover)="showSubMenu[2] = true;hoverLinks = true;" (mouseleave)="delayedLeave(2)">Links</a>
            @if (showSubMenu[2] == true) {
              <div id="p7DMMs2_3" class="p7dmm-sub-wrapper" style="height: 0px;">
                <ul class="scroll" (mouseover)="hoverScroll = true;showSubMenu[2] = true;" (mouseleave)="ScrollDelayedLeave(2)">
                  <li><a href="http://www.racketlon.com/rackrules.html" target="_blank">Rules of Racketlon</a></li>
                  <li><a href="https://fir.tournamentsoftware.com/home" target="_blank">Federation of International Racketlon</a></li>
                  <li><a href="https://www.racketlon.co.uk/" target="_blank">UK Racketlon</a></li>
                  <li><a href="https://www.facebook.com/racketlonNZ/" target="_blank">Racketlon NZ on Facebook</a></li>
                  <li><a href="https://tennis.org.nz/" target="_blank">NZ Tennis Rankings</a></li>
                  <li><a href="https://www.sporty.co.nz/asset/downloadasset?id=9fbc38af-5d32-4d3d-af46-26409cbd542d" target="_blank">NZ Table Tennis Rankings</a></li>
                  <li><a href="https://www.squash.org.nz/sit/grading#/summary" target="_blank">NZ Squash Rankings</a></li>
                  <li><a href="https://bnz.tournamentsoftware.com/ranking/ranking.aspx?rid=271" target="_blank">NZ Badminton Rankings</a></li>
                </ul>
              </div>
            }
          </li>
          @if (DataService.LoggedInUser?.accessLevel > 2) {
            <li class="closed">
              <a id="Database" title="Database" (click)="goDatabase()" class="closed">Database</a>
            </li>
          }
          @if (DataService.LoggedInUser?.accessLevel > 2) {
            <li class="closed">
              <a id="btnUserMaintenance" title="btnUserMaintenance" (click)="goUserMaintenance()" class="closed">User Maintenance</a>
            </li>
          }
          <li class="closed">
            <a id="btnVideoFiles" title="btnVideoFiles" (click)="goVideoFiles()" class="closed">Videos</a>
          </li>
          <li class="closed">
            @if (!DataService.LoggedInUser) {
              <a title="Login to enter tournaments" runat="server" (click)="goLogin()">Login</a>
            }
            @if (DataService.LoggedInUser?.name) {
              <a class="UserNameText" runat="server" (click)="goLogin()">{{DataService.LoggedInUser?.name}}</a>
            }
          </li>

        </ul>
        <!-- <label *ngIf="LoginState.AccessLevel > 2">{{Version}}</label> -->
        <!-- <label *ngFor="let folder of GalleryFolders">{{folder}}</label> -->
      </div>
    </div>
  </div>
</div>
